import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "links" }
const _hoisted_2 = { class: "news" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_ArticleCard = _resolveComponent("ArticleCard")
  const _component_Carousel = _resolveComponent("Carousel")
  const _component_CollapseMenu = _resolveComponent("CollapseMenu")

  return (_openBlock(), _createBlock(_component_CollapseMenu, {
    loading: $options.loading,
    class: "collapse-menu",
    title: $options.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($options.summary)
          ? (_openBlock(), _createBlock(_component_MdContent, {
              key: 0,
              class: "summary",
              markdown: $options.summary
            }, null, 8 /* PROPS */, ["markdown"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Carousel, {
            class: "carousel",
            value: $options.content,
            "num-visible": 2,
            "num-scroll": 2,
            "show-navs": $options.show_navs,
            orientation: "vertical",
            "vertical-view-port-height": $options.v_heihgt
          }, {
            item: _withCtx(({slotProps}) => [
              _createVNode(_component_ArticleCard, {
                class: "link-item",
                flat: "",
                preview: slotProps.preview,
                source: slotProps.source,
                "relative-date": slotProps.relative_date,
                date: slotProps.date
              }, null, 8 /* PROPS */, ["preview", "source", "relative-date", "date"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "show-navs", "vertical-view-port-height"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["loading", "title"]))
}